import { Styles, StylesWithFloaterStyles } from 'react-joyride'
import { trackInternalEvent } from '@rio/tracking'

export const Z_INDEX = 10000
export const TRANSLATION_KEY = 'builder.resume_editor.tour_steps'

export const animationStyles = {
  opacity: 0,
  transition: 'none',
  animation: 'fadeIn 350ms ease-in-out 150ms forwards',
}

export const fadeOutStyles = {
  opacity: 1,
  animation: 'fadeOut 350ms ease-in-out',
}

export const getOverlayStepStyle = (): Partial<Styles['options']> => {
  return {
    zIndex: 10000,
    overlayColor: 'rgba(0, 0, 0, 0.01)',
  }
}

export const getFloaterStepStyles = (
  withoutAnimation?: boolean,
): Partial<StylesWithFloaterStyles['floaterStyles']> => {
  return {
    floater: { filter: 'none', ...(withoutAnimation ? {} : animationStyles) },
    floaterOpening: withoutAnimation ? {} : { opacity: 0 },
    floaterWithAnimation: withoutAnimation ? {} : { opacity: 0 },
  }
}

export const overlayClickCallback = () => {
  const overlay: HTMLElement | null = document.querySelector('.react-joyride__overlay')
  if (!overlay) return

  overlay.onclick = () => trackInternalEvent('rb_onboarding_misclick')
}

export const isPhrasesSuggestionsStepPresent = () => {
  return !!document.getElementById('phrases-suggestion-toggler')
}
